import React from 'react';
import BaseComponent, {AjaxParam} from '../../common/BaseComponent/BaseComponent';
import Select from "../../common/primitives/Select";
import Radio from "../../common/primitives/Radio";
import TextBox from "../../common/primitives/TextBox";
import TextArea from "../../common/primitives/TextArea";
import Submit from "../../common/primitives/Submit";
import CloseButton from "../../common/primitives/CloseButton";

import styles from './ComponentDomainContactData.scss';
import textBoxStyles from '../../common/primitives/TextBox.scss';
import textAreaStyles from '../../common/primitives/TextArea.scss';
import radioStyles from '../../common/primitives/Radio.scss';
import Loading from "../../common/primitives/Loading";
import {_translateToLatin} from "../../common/helpers/HelperFunc";
import Button from "../../common/primitives/Button";
import buttons from "../../common/primitives/Button.scss";
import Checkbox from "../../common/primitives/CheckBox";
import checkBoxStyles from "../../common/primitives/CheckBox.scss";
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import {__t} from "../../common/lang/text-resource";


class ComponentDomainContactData extends BaseComponent {

	selected = '';
	isCompany = null;
	componentVisible = false;
	error = {};


	componentDidMount() {
		super.componentDidMount();
		document.addEventListener('keydown', this.onEsc, false)
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.onEsc, false)
	}

	onEsc = (event) => {
		if (this.componentVisible && event.keyCode === 27) {
			this.hide();
		}
	};
	changeContactType = event => {
		this.isCompany = event.target.value === 'company';
		this.setState(this.state);
	};
	onChangeApplyToAllDomains = checked => {
		let {contactData} = this.state.componentData;
		contactData.applyToAllDomains = checked;
		this.state.componentData.contactData = contactData;
		this.setState(this.state);
	};
	onChange = event => {
		let {contactData} = this.state.componentData;
		contactData[event.target.name] = event.target.value;
		this.state.componentData.contactData = contactData;
		this.error[event.target.name] = '';
		this.setState(this.state);
	};

	onChangeSelect = (selectedOption, selectName) => {
		let {contactData} = this.state.componentData;
		contactData[selectName] = selectedOption.value;
		this.state.componentData.contactData = contactData;
		this.error[selectName] = '';
		this.setState(this.state);
	};

	hide = () => {
		this.componentVisible = false;
		this.setState(this.state);
		this.eventRaise('DomainContactDataPopupToggled', {visible: false});
	};

	validate = () => {
		let componentData = this.state.componentData;
		if (!this.isCompany) {
			componentData.contactData.company = '';
		}


		let {contactData} = componentData;
		const requiredFields = {
			mail: true,
			personFname: true,
			personLname: true,
			city: true,
			address1: true,
			postcode: true,
			phone1: true,
			phone1Code: true,
			company: this.isCompany,
			country: 1,
		};
		this.error = {};
		let hasError = false;
		Object.keys(contactData).map((key) => {

			const value = contactData[key];
			if (requiredFields[key] && value === '') {
				this.error[key] = this.messages[`WHOIS_${key.toUpperCase()}_ERROR`];
				hasError = true;
			}
		});
		this.setState(this.state);

		return !hasError;
	};

	onSubmit = event => {
		event.preventDefault();
		this.loading = true;
		this.setState(this.state);
		if (!this.validate()) {
			this.loading = false;
			this.setState(this.state);
			return false;
		}

		let componentData = this.state.componentData;
		if (!this.isCompany) {
			componentData.contactData.company = '';
		}

		let {contactData, cartLineId} = componentData;
		let ajaxParam = new AjaxParam();
		ajaxParam.callbackSuccess = () => {
			this.componentVisible = false;
			this.loading = false;
			this.eventRaise('WhoisDataChanged');
		};
		this.ajaxCall('ActionSetWhoisData', {contactData, cartLineId, isCompany: this.isCompany}, ajaxParam);
	};

	render() {
		if (!this.componentVisible) {
			return <div/>
		} else {

			if (this.loading) {
				return (
				  <section className={`${styles.container}`}>
					  <div data-layout="center row middle gutter-none" className={styles.loading}>
						  <div data-layout="col 12">
							  <Loading/>
						  </div>
					  </div>
				  </section>
				);
			}


			const {
				phones,
				countries,
				countNewDomains,
				domainName,
				tld,
				contactData: {
					mail,
					personFname,
					personLname,
					company,
					country,
					city,
					address1,
					postcode,
					phone1,
					phone1Code,
					applyToAllDomains,
					invalidDomainCountry
				}
			} = this.state.componentData;

			if (this.isCompany === null) {
				this.isCompany = (company !== '' && company !== 'undefined');
			}


			let countryError = this.error.country;
			if (invalidDomainCountry) {
				countryError = __t('регистрацията-на-EU-домейн-изисква-задължително-аe48ad2');
				if (tld === 'uk') {
					countryError = __t('регистрацията-на-UK-домейн-изисква-задължително-а70234a');
				}
			}

			return (
			  <section className={`${styles.container}`}>
				  <div>

					  <div className={styles.closeButton}>
						  <CloseButton onClick={this.hide} altText={__t('Затвори')}/>
					  </div>
					  <div data-layout="row gutter-none start" className={styles.headerContainer}>
						  <div data-layout="col 12">
							  <h1>{__t('Данни за контакт :domainName', {domainName: domainName !== '' ? '-' + domainName : ''})}</h1>
						  </div>
					  </div>
					  <form onSubmit={this.onSubmit} data-test='domain-contact-data-form'>
						  <div data-layout="margin-top--smm padding-top--xxs">

							  <div data-layout="row gutter-none start margin-top--xs">
								  <div data-layout="col 12 8@md offset-4@md">
									  <p>{__t('* Задължителни полета (латиница)')}</p>
								  </div>
							  </div>
							  <div data-layout="row start gutter-none">
								  <div data-layout="col 12" className={styles.innerContainer}>
									  <div data-layout="row gutter-none start">
										  <div data-layout="col 12 8@md offset-4@md">
											  <div data-layout="row gutter-none middle">
												  <div
													data-layout="col 12 margin-bottom--xs padding-bottom--xxs"
													className={styles.radioContainer}>
													  <Radio
														checkmarkClass={radioStyles.transparent}
														label={__t('Частно лице')}
														value={'person'}
														checked={!this.isCompany}
														onChange={this.changeContactType}
														name={'contact_type'}/> &nbsp;&nbsp;&nbsp;&nbsp;
													  <Radio
														checkmarkClass={radioStyles.transparent}
														label={__t('Организация')}
														value={'company'}
														checked={this.isCompany}
														onChange={this.changeContactType}
														name={'contact_type'}/>
												  </div>
											  </div>
										  </div>
									  </div>
									  {
										  (this.isCompany) ?
											<div data-layout="row gutter-none middle">
												<div data-layout="col 12 4@md" className={styles.labelContainer}>
													<label htmlFor="whois_company">
														<span>*</span> {__t('име на организация')}
													</label>
												</div>
												<div
												  data-layout="col 12 8@md margin-bottom--xs padding-bottom--xxs">
													<TextBox
													  className={textBoxStyles.transparent}
													  id={'whois_company'}
													  name={'company'}
													  error={this.error.company}
													  value={_translateToLatin(company)}
													  onChange={this.onChange}
													  placeholder={__t('ABV Design EOOD')}/>
												</div>
											</div>
											: ''
									  }

									  <div data-layout="row gutter-none middle">
										  <div data-layout="col 12 4@md" className={styles.labelContainer}>
											  <label htmlFor="whois_person_name">
												  <span>*</span> {__t('име')}
											  </label>
										  </div>
										  <div data-layout="col 12 8@md  margin-bottom--xs padding-bottom--xxs">
											  <TextBox
												className={textBoxStyles.transparent}
												id={'whois_person_name'}
												name={'personFname'}
												error={this.error.personFname}
												value={_translateToLatin(personFname)}
												onChange={this.onChange}
												required={true}
												placeholder={__t('Ivan')}/>
										  </div>
									  </div>
									  <div data-layout="row gutter-none middle">
										  <div data-layout="col 12 4@md" className={styles.labelContainer}>
											  <label htmlFor="whois_person_lname">
												  <span>*</span> {__t('фамилия')}
											  </label>
										  </div>
										  <div data-layout="col 12 8@md margin-bottom--xs padding-bottom--xxs">
											  <TextBox
												className={textBoxStyles.transparent}
												name={'personLname'}
												id={'whois_person_lname'}
												error={this.error.personLname}
												value={_translateToLatin(personLname)}
												onChange={this.onChange}
												required={true}
												placeholder={__t('Ivanov')}/>
										  </div>
									  </div>
									  <div data-layout="row gutter-none middle">
										  <div data-layout="col 12 4@md" className={styles.labelContainer}>
											  <label htmlFor="whois_person_email">
												  <div data-layout="hide@md"><span>*</span> {__t('електронна поща')}
												  </div>
												  <div data-layout=" hide show@md"><span>*</span> {__t('ел. поща')}
												  </div>
											  </label>
										  </div>
										  <div data-layout="col 12 8@md margin-bottom--md">
											  <TextBox
												className={textBoxStyles.transparent}
												type={'email'}
												id={'whois_person_email'}
												name={'mail'}
												error={this.error.mail}
												value={_translateToLatin(mail)}
												onChange={this.onChange}
												required={true}
												placeholder={__t('ivanivanov@mail.com')}/>
										  </div>
									  </div>
									  <div data-layout="row middle gutter-none">
										  <div data-layout="col 4 hide show@md" className={styles.labelContainer}>
											  <label htmlFor="whois_phone">
												  <span>*</span> {__t('телефон')}
											  </label>
										  </div>
										  <div data-layout="col 12 8@md">
											  <div
												data-layout="row gutter-none start"
												className={styles.multiColContainer}>

												  <div data-layout="col 4 hide@md">
													  <label htmlFor="whois_code">
														  <span>*</span> {__t('код')}
													  </label>
												  </div>
												  <div data-layout="col 8 hide@md">
													  <label htmlFor="whois_phone">
														  <span>*</span> {__t('телефон')}
													  </label>
												  </div>
												  <div data-layout="col 4 margin-bottom--xs padding-bottom--xxs">
													  <Select
														selected={phone1Code}
														name={'phone1Code'}
														id={'whois_code'}
														error={this.error.phone1Code}
														options={phones}

														placeholder={'999'}
														required={true}
														isGrouped={tld !== 'uk'}
														isTransparent={true}
														onChange={(selectedOption => this.onChangeSelect(selectedOption, 'phone1Code'))}/>
												  </div>
												  <div data-layout="col 8 margin-bottom--xs padding-bottom--xxs">
													  <TextBox
														className={textBoxStyles.transparent}
														name={'phone1'}
														id={'whois_phone'}
														error={this.error.phone1}
														value={_translateToLatin(phone1)}
														placeholder={'99 999 99 99'}
														required={true}
														onChange={this.onChange}/>
												  </div>
											  </div>
										  </div>
									  </div>
									  <div data-layout="row gutter-none middle">
										  <div data-layout="col 12 4@md" className={styles.labelContainer}>
											  <label htmlFor="whois_country">
												  <span>*</span> {__t('държава')}
											  </label>
										  </div>
										  <div data-layout="col	12 8@md margin-bottom--xs padding-bottom--xxs">

											  <Select
												selected={country}
												name={'country'}
												error={countryError}
												options={countries}

												placeholder={__t('България')}
												required={true}
												isGrouped={tld !== 'uk'}
												isTransparent={true}
												onChange={(selectedOption => this.onChangeSelect(selectedOption, 'country'))}/>

										  </div>
									  </div>
									  <div
										data-layout="row gutter-none middle"
										className={`${styles.multiColContainer} ${styles.cityContainer}`}>

										  <div data-layout="col 8 4@md first@md" className={styles.labelContainer}>
											  <label htmlFor="whois_city">
												  <span>*</span> {__t('град')}
											  </label>
										  </div>

										  <div data-layout="col 4 2@md " className={styles.labelContainer}>
											  <label htmlFor="whois_postcode" data-layout="padding-right--xs">
												  <span>*</span> {__t('пк')}
											  </label>
										  </div>
										  <div
											data-layout="col 8 4@md first@md  margin-bottom--xs padding-bottom--xxs">
											  <TextBox
												className={textBoxStyles.transparent}
												name={'city'}
												id={'whois_city'}
												value={_translateToLatin(city)}
												error={this.error.city}
												placeholder={__t('Sofia')}
												required={true}
												onChange={this.onChange}/>
										  </div>
										  <div
											data-layout="col 4 2@md margin-bottom--xs padding-bottom--xxs">
											  <TextBox
												className={textBoxStyles.transparent}
												name={'postcode'}
												id={'whois_postcode'}
												value={_translateToLatin(postcode)}
												error={this.error.postcode}
												placeholder={'1000'}
												required={true}
												onChange={this.onChange}/>
										  </div>
									  </div>
									  <div data-layout="row gutter-none middle">
										  <div data-layout="col 12 4@md" className={styles.labelContainer}>
											  <label htmlFor="whois_address">
												  <span>*</span> {__t('адрес')}
											  </label>
										  </div>
										  <div data-layout="col 12 8@md margin-bottom--md">
											  <TextArea
												name={'address1'}
												error={this.error.address1}
												placeholder={__t('36 D-r G. M. Dimitrov Blvd')}
												id={'whois_address'}
												value={_translateToLatin(address1)}
												className={textAreaStyles.transparent}
												required={true}
												onChange={this.onChange}/>

										  </div>
									  </div>
									  {
										countNewDomains > 1 && <div data-layout="row gutter-none middle">
											<div data-layout="col 12 4@md" className={styles.labelContainer}/>
											<div data-layout="col 12 8@md margin-bottom--md">
												<table className={styles.checkboxLabelContainer}>
													<tbody>
													<tr>
														<td>
															<Checkbox
															  name='applyToAllDomains'
															  checked={applyToAllDomains}
															  customOnchange={this.onChangeApplyToAllDomains}
															  className={checkBoxStyles.transparent}
															/>
														</td>
														<td>
															<label className={styles.checkboxLabel}
																   htmlFor='applyToAllDomains'>
																{__t('използвай-данните-за-този-домейн-за-всички-останаf9bb0e')}
															</label>
														</td>
													</tr>
													</tbody>
												</table>
											</div>
										</div>
									  }
									  <div data-layout="row gutter-none middle">
										  <div data-layout="col 12 4@md" className={styles.labelContainer}/>
										  <div data-layout="col 12 8@md margin-bottom--md">
											  {__t('регистрантът-носи-пълната-отговорност-за-достовер884af1')}
										  </div>
									  </div>
									  <div data-layout="row gutter-none middle">
										  <div data-layout="col 12 4@md" className={styles.labelContainer}/>
										  <div data-layout="col 12 8@md margin-bottom--md">
											  {__t('регистрарът-си-запазва-правото-да-ограничи-функци029dc4')}
										  </div>
									  </div>
								  </div>
							  </div>
						  </div>
						  <div
							className={styles.submitButtonContainer}
							data-layout="text-center margin-top--lg margin-bottom--lg padding-bottom-smm">
							  <div data-layout="row gutter-none start">
								  <div data-layout="col 12 8@md offset-4@md">
									  <Submit value={__t('Запазване')}/>
								  </div>
							  </div>
							  <div data-layout="row gutter-none start">
								  <div data-layout="col 12 8@md offset-4@md">
									  <Button onClick={this.hide} name={'closeBtn'} value={__t('Затвори')}
											  className={buttons.btnGray}/>
								  </div>
							  </div>
						  </div>
					  </form>
				  </div>
			  </section>
			);
		}
	}
}


// React Context binding
ComponentDomainContactData.contextType = ContextDataStore;

export default ComponentDomainContactData;